module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/~/babel-runtime/core-js/object/define-property.js
// module id = ../../../../babel-runtime/core-js/object/define-property.js
// module chunks = 42